import { Api } from '@community_dev/types'
import { useQueryClient } from '@tanstack/react-query'
import type { JSX } from 'react'
import { CamelCasedPropertiesDeep } from 'type-fest'

import { useChopperDomain } from '../../hooks/useChopperDomain'
import { ONBOARDING_MESSAGE_TITLES } from '../constants'

import { Client, putFanOnboardingMessage } from 'api/clients'
import { QUERIES } from 'constants/queries'
import { InlineEditMessage } from 'shared/components/InlineEditMessage'

type SubscriptionConfirmationMessage = CamelCasedPropertiesDeep<Api.OnboardingSubscriptionConfirmationMessage>

export type OnboardingMessages = CamelCasedPropertiesDeep<Api.OnboardingMessage[]>

type EditLegalOnboardingMessageProps = {
  client: Client
  message: SubscriptionConfirmationMessage
}

export const EditSubscriptionMessage = ({ client, message }: EditLegalOnboardingMessageProps): JSX.Element => {
  const queryClient = useQueryClient()
  const chopperDomain = useChopperDomain(client.id, client.whiteLabelEnabled ?? false)
  const { clientId, id, label, text, maxLength, maxSegmentCount, tcpa } = message

  const invalidateClient = (id: any) => {
    queryClient.invalidateQueries([QUERIES.CLIENT, { id }])
  }

  return (
    <InlineEditMessage
      chopperDomain={chopperDomain}
      defaultValue={text}
      maxLength={maxLength}
      maxSegment={maxSegmentCount}
      name={ONBOARDING_MESSAGE_TITLES[label]}
      onSuccess={invalidateClient}
      prepare={(value) => ({
        id: clientId,
        messageId: id,
        body: { text: value },
      })}
      requiredSuffix={tcpa}
      updateEntity={putFanOnboardingMessage}
    />
  )
}
